// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

import Department from "./Department";
import LicenseType from "enums/LicenseType";
import Location from "./Location";
import Team from "./Team";
import User, { processUser } from "./User";
import Util from "PreciateUtil";

export default interface Member {
    invitedDateTime?: Date;
    joined?: boolean;
    joinedDateTime?: Date;
    isAdmin?: boolean;
    emailAddress?: string;
    emailSent?: boolean;
    emailedDateTime?: Date;
    user?: User;
    team?: Team;
    department?: Department;
    location?: Location;
    license?: LicenseType;
}

export function processMember(value?: Member): void {
  if (value) {
    value.invitedDateTime = Util.toDate((value as any).invitedDateTime);
    value.joinedDateTime = Util.toDate((value as any).joinedDateTime);
    value.emailedDateTime = Util.toDate((value as any).emailedDateTime);
    processUser(value.user);
  }
}

export function processMemberArray(array?: Member[]): void {
  if (array) {
    for (const v of array) {
      processMember(v);
    }
  }
}
